import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {CartState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class CartQuery extends QueryEntity<CartState> {

  constructor(protected store: Store) {
    super(store);
  }

}
